import React from 'react'
import Link from 'gatsby-link'
import Menu from '../menu'

const Header = () => (
  <div
    style={{
      background: '#171717',
      textAlign: 'center',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0.45rem 1.0875rem',
      }}
    >

      <h1 style={{
        margin: 0,
      }}>
        <Link
          to="/"
          style={{
            color: '#cfcfcf',
            textDecoration: 'none',
          }}
        >
          <img src="https://s3.amazonaws.com/vdr/site_assets/logo-sm.png" />
        </Link>
      </h1>

      <Menu></Menu>

    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js